export default __webpack_public_path__ + "static/char-s-11-jp-450b85b5175716f7129269812319b7c6.webp";